import { render, staticRenderFns } from "./FreshChatHolidaysPopup.vue?vue&type=template&id=73c4b407&scoped=true"
import script from "./FreshChatHolidaysPopup.vue?vue&type=script&lang=js"
export * from "./FreshChatHolidaysPopup.vue?vue&type=script&lang=js"
import style0 from "./FreshChatHolidaysPopup.vue?vue&type=style&index=0&id=73c4b407&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c4b407",
  null
  
)

export default component.exports